import { LayoutContainer } from 'components/Layout';
import Link from 'components/Link';
import RichText from 'components/RichText';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import type { HTMLString } from 'types';
import { getEditorMargin } from 'utils/business-logic';
import { is } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		manufacturerInfo?: {
			address?: {
				city: string;
				country: string;
				postalCode: string;
				street1: string;
				street2: string;
			};
			email?: string;
			id: string;
			name: string;
			uri?: string;
		};
		manufacturerInfoMissingText?: Field<HTMLString>;
	};
}

export default function ManufacturerInfo({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { manufacturerInfo, manufacturerInfoMissingText } = fields;

	const address = manufacturerInfo?.address;
	const email = manufacturerInfo?.email;
	const uri = manufacturerInfo?.uri;
	const lines = [
		manufacturerInfo?.name,
		address?.street1,
		address?.street2,
		[address?.postalCode, address?.city].filter(is.truthy).join(' '),
		address?.country,
	].filter(is.truthy);

	const hasManufacturerInfo = is.arrayWithLength(lines) || email || uri;

	return (
		<LayoutContainer outerClassName={getEditorMargin(params)}>
			{hasManufacturerInfo ? (
				<address className="wrap-break-word not-italic">
					{lines.map((line) => (
						<span key={line} className="block">
							{line}
						</span>
					))}
					{email && (
						<Link href={`mailto:${email}`} className="block" underline>
							{email}
						</Link>
					)}
					{uri && (
						<Link href={uri} className="block" target="_blank" underline>
							{uri}
						</Link>
					)}
				</address>
			) : (
				<RichText field={manufacturerInfoMissingText} />
			)}
		</LayoutContainer>
	);
}
ManufacturerInfo.displayName = 'ManufacturerInfo_Partial';
